export function getSvgBoxSize($svg) {
	var values = $svg[0].getAttribute('viewBox').split(' ');
	return {
		width: values[2] - values[0],
		height: values[3] - values[1]
	};
}

export function getFittedSvgSize($svg, width) {
	var svgBoxSize = getSvgBoxSize($svg);
	var newHeight = width / svgBoxSize.width * svgBoxSize.height;
	newHeight = Math.round(newHeight * 10) / 10;
	return {
		width: width,
		height: newHeight
	};
}

export function fitSvgSizeToWidth($container, $svg) {
	var svgBoxSize = getSvgBoxSize($svg);
	var ratio = svgBoxSize.height / svgBoxSize.width * 100;

	$container
		.css('position', 'relative')
		.attr('height', '0')
		.attr('width', '100%')
		.css('padding', '0')
		.css('padding-bottom', ratio + '%');

	$svg
		.css('position', 'absolute')
		.attr('width', '100%')
		.attr('height', '100%')
		.css('left', '0')
		.css('top', '0');
}



/** WEBPACK FOOTER **
 ** ./frontend/components/svg/svgSize.js
 **/